function SystemsightEshop(options) {
    var defaults = {
        version: '1.0.2',

        useAfterAddPopup: true,

        //html
        preloaderHtml: '<div id="eshop-form-preloader" class="position-fixed" style="left: 50%; top: 50%; transform: translate(-50%, 0);"><div class="spinner-border" role="status"><span class="sr-only">Loading...</span></div></div>',

        //selectors
        productItemSelector: '.eshop-p-item',
        add2CartBtnSelector: '.eshop-add2cart',
        variantPriceSelector: '.eshop-pv-price',
        variantSelectorSelector: '.eshop-pv-select',
        productQuantitySelector: '#eshop-p-quantity-',
        productVariantQuantitySelector: '#eshop-pv-quantity-',
        productVariantDataWrapSelector: '[data-wrap="pv-data"]',

        quantityIncreaseSelector: '.eshop-quantity-increase',
        quantityDecreaseSelector: '.eshop-quantity-decrease',

        cartQuantitySelector: '.eshop-oi-quantity',
        cartDeleteSelector: '.eshop-oi-delete',

        cartOrderItemRowSelector: '.ehop-oi-row',
        cartOrderItemTotalPriceSelector: '.ehop-oi-total-price',
        cartWidgetSelector: '.eshop-cart-widget',
        cartSummarySelector: '.eshop-cart-summary',
        cartCartTimeleftSelector: '.eshop-cart-timeleft',

        autosubmitGroup: '.eshop-autosubmit-group',
        cartShippingFormSelector: '#userdata-form',
        cartShippingCountryInputSelector: 'select[name="shipping\[country\]"]',
        cartShippingCityInputSelector: 'select[name="shipping\[city\]"]',
        cartShippingMethodInputsSelector: 'input[name="shipping_method"]',
        cartShippingMethodInputSelector: 'input[name="shipping_method"]:checked',
        cartShippingDataSelector: '[data-eshop-shipping-data]',
        cartShippingPriceSelector: '[data-eshop-shipping-price]',
        modalLinkSelector: '[data-eshop-modal-link]',
        addressSelector: '.address-selector',

        //api urls
        baseUrl: (typeof eshopBaseUrl === "string") ? eshopBaseUrl : "/eshop",
        add2CartUrl: "/cart/item/add",
        updateCartItemQuantityUrl: "/cart/item/quantity",
        cartWidgetUrl: "/cart/widget",
        cartUrl: "/cart",
        afterAddToCartUrl: "/cart/after_item_add",
        addressPreviewUrl: "/address/preview",
        addressSelectorUrl: "/address/selector",
        shippingDataUrl: "/cart/shipping/method/settings",
        shippingPriceUrl: "/cart/shipping/method/price",
        assignAddressUrl: "/cart/checkout/assign_address",
    };

    var that = this;
    options = options || {};

    that.options = $.extend(true, {}, defaults, options);

    that.init();
}

SystemsightEshop.prototype.init = function () {
    var that = this;
    that.initAdd2CartBtns();
    that.initVariantsSelector();

    that.initCartView();

    that.initCartTimeleftTrackers();
    that.initQuantityControls();

    that.initAutosubmitSelectGroup();
    that.initPopupLinks();

    that.initAddressSelectors();

    that.initShippingMethodForm();

    console.log('SystemsightEshop inited (' + that.options.version + ')');
};

//initis
SystemsightEshop.prototype.initAddressSelectors = function () {
    var that = this;

    $(that.options.addressSelector).each(function () {
        var $group = $(this);
        if ($group.data('inited')) return;

        var $groupWrap = $(this).parents('.address-selector-wrap');
        var type = $group.data('type');
        var $input = $group.find('.eshop-address-selector');
        var $previewWrap = $group.find('.address-preview-wrap');


        function reloadWrap() {
            var xhrKey = type + "addressSelectorWrap_xhr";
            if (that[xhrKey]) that[xhrKey].abort();
            $groupWrap.fadeTo(300, 0.3);

            that[xhrKey] = $.ajax({
                url: that.options.baseUrl + that.options.addressSelectorUrl,
                data: {
                    ajax: true,
                    address_type: type
                }
            }).done(function (result) {
                $groupWrap.replaceWith(result);
                that.initAddressSelectors();
                that.reinitInputs();
            })

        }

        $group.find(that.options.modalLinkSelector).data('afterClose', function (e) {
            reloadWrap();
        });

        $input.on('change', function (e) {
            var xhrKey = type + "addressAssign_xhr";
            var addressId = $input.val();
            if (that[xhrKey]) that[xhrKey].abort();

            that[xhrKey] = $.ajax({
                url: that.options.baseUrl + that.options.assignAddressUrl,
                data: {
                    ajax: true,
                    _token: $group.parents('form').find('input[name="_token"]').val(),
                    address: addressId
                }
            }).done(function (result) {
                reloadWrap();
            })

        });

        $group.data('inited', true);
    })
};

SystemsightEshop.prototype.reinitInputs = function () {
    init_select2_all();
};

SystemsightEshop.prototype.initShippingMethodForm = function () {
    let that = this;
    let order = typeof CART_ORDER_ID != 'undefined' ? CART_ORDER_ID : null;
    let $form = $(that.options.cartShippingFormSelector);

    if($form.length == 0) return;

    let initCountryChange = function(){
        $(that.options.cartShippingCountryInputSelector).on('change', function () {
            that.updateShippingMethodPrice();
        });
        that.updateShippingMethodPrice();
    };

    $(that.options.cartShippingFormSelector)
        .find(that.options.cartShippingMethodInputsSelector)
        .on('change', function () {
            let $input = $(this);
            let shippingMethod = $input.val();

            that.showFormPreloader($form);

            $.ajax({
                url: that.options.baseUrl + that.options.shippingDataUrl,
                data: {
                    ajax: true,
                    shipping_method: shippingMethod
                }
            }).done(function (result) {

                $(that.options.cartShippingDataSelector).html(result);
                that.reinitInputs();
                initCountryChange(that);
                that.hideFormPreloader($form)
            });
        });

    initCountryChange();
};

SystemsightEshop.prototype.initAdd2CartBtns = function () {
    var that = this;
    $("body").on('click', that.options.add2CartBtnSelector, function (e) {
        that.onAdd2CartBtnClick(this, e)
    });
};
SystemsightEshop.prototype.initVariantsSelector = function () {
    var that = this;
    $("body").on('change', that.options.variantSelectorSelector, function (e) {
        that.onVariantChange(this, e)
    });
};

SystemsightEshop.prototype.initCartView = function () {
    var that = this;
    if ($(that.options.cartSummarySelector).length) {
        that.initCartQuantityChange();
        that.initCartDelete();
    }
}
SystemsightEshop.prototype.initPopupLinks = function () {
    var that = this;
    $("body").on('click', that.options.modalLinkSelector, function (e) {
        var $that = $(this);
        $.fancybox.open({
            src: $(this).data("src"),
            type: $(this).data("type"),
            toolbar: false,
            smallBtn: true,
            afterClose: function (e) {
                if ($that.data('afterClose')) {
                    $that.data('afterClose')();
                }
            },
            afterLoad: function (e) {
            },
            iframe: {
                preload: true,
                css: {
                    width: '80%',
                    maxWidth: 1000
                }
            }
        });
    });

};


SystemsightEshop.prototype.initCartQuantityChange = function () {
    var that = this;
    $("body").on('change', that.options.cartQuantitySelector, function (e) {
        that.onCartQuantityChange(this, e)
    });
};

SystemsightEshop.prototype.initQuantityControls = function () {
    var that = this;
    $("body").on('click', that.options.quantityIncreaseSelector, function (e) {
        var $cartQuantityInput = $($(this).data('target'));
        if ($cartQuantityInput[0].disabled) return;
        var max = $cartQuantityInput.attr('max');
        var currentVal = parseInt($cartQuantityInput.val());
        if (max == undefined || currentVal < max) {
            $cartQuantityInput.val(currentVal + 1).change();
        }

    });
    $("body").on('click', that.options.quantityDecreaseSelector, function (e) {
        var $cartQuantityInput = $($(this).data('target'));
        if ($cartQuantityInput[0].disabled) return;
        var min = typeof $cartQuantityInput.attr('min') !== "undefined" ? parseInt($cartQuantityInput.attr('min')) : 1;
        var currentVal = parseInt($cartQuantityInput.val());

        if (currentVal > min) {
            $cartQuantityInput.val(currentVal - 1).change();
        }

    });
    $("body").on('change', '.eshop-oi-quantity', function () {
        var $cartQuantityInput = $(this);
        var v = $cartQuantityInput.val();
        var min = typeof $cartQuantityInput.attr('min') !== "undefined" ? parseInt($cartQuantityInput.attr('min')) : 1;
        var max = typeof $cartQuantityInput.attr('max') !== "undefined" ? parseInt($cartQuantityInput.attr('max')) : 0;

        if(max && v > max){
            $cartQuantityInput.val(max).change();
        }else if(v < min){
            $cartQuantityInput.val(min).change();
        }
    })
}


SystemsightEshop.prototype.initCartDelete = function () {
    var that = this;
    $("body").on('click', that.options.cartDeleteSelector, function (e) {
        e.preventDefault();
        that.onCartDeleteItem(this, $(this).attr("href"));
    });
};

SystemsightEshop.prototype.initCartTimeleftTrackers = function () {
    var that = this;
    $(that.options.cartCartTimeleftSelector).each(function () {
        var $timer = $(this);
        if ($timer.data("inited")) return;

        $timer.data("start", Math.round((new Date()).getTime() / 1000))

        var intId = setInterval(function () {
            if ($timer.parents('html').length) {
                that.updateTimer($timer);
            } else {
                clearInterval($timer.data("inited"))
            }
        }, 1000)
        $timer.data("inited", intId);
        that.updateTimer($timer);
    })
}
SystemsightEshop.prototype.initAutosubmitSelectGroup = function () {
    var that = this;

    $(that.options.autosubmitGroup).each(function () {
        var $group = $(this);
        var $form = $group.parents('form');

        $group.find("input[type='radio'], input[type='checkbox'], select").on('change', function (e) {
            $group.find('.eshop-autosubmit-group-change').val(1).attr("disabled", null);
            that.showFormPreloader($form)
            $group.parents('form').submit();
        })
    });
}


//events
SystemsightEshop.prototype.onAdd2CartBtnClick = function (target, e) {
    var that = this;
    e.preventDefault();

    var pId = $(target).data("product");
    var variantId = $(target).data("variant");

    //multiple variant add
    var vIds = [];

    var variants = $(target).data("variants");
    if (variants) {
        if (typeof variants === 'string' || variants instanceof String) {
            vIds = variants.split(',');
        } else {
            vIds.push(variants)
        }
    } else {
        vIds.push(variantId);
    }

    var pQuantity = 1;

    if ($(that.options.productQuantitySelector + pId).length) {
        pQuantity = $(that.options.productQuantitySelector + pId).val();
    }

    var variantsToAdd = [];


    for (var k in vIds) {
        var vId = vIds[k];
        var vQuantity = pQuantity;
        if ($(that.options.productVariantQuantitySelector + vId).length) {
            vQuantity = $(that.options.productVariantQuantitySelector + vId).val();
        }

        if (vQuantity > 0) {
            variantsToAdd.push(vId + "." + vQuantity);
        }
    }

    if (variantsToAdd.length > 0) {
        $(target).attr("disabled", "disabled").find('.eshop-preloader').show();
        that.add2Cart(variantsToAdd, $(target).data("token"), function (result) {
            $(target).attr("disabled", null).find('.eshop-preloader').hide();
        })
    } else {
        console.log('quantity is empty')
    }
};
SystemsightEshop.prototype.onVariantChange = function (target, e) {
    var that = this;

    var $wrap = $(target).parents(that.options.productItemSelector);

    $wrap.find(that.options.add2CartBtnSelector)
        .data("variant", target.value)
        .attr("data-variant", target.value);
    //that.updateVariantPrice($wrap, target.value);
    $wrap.find(that.options.productVariantDataWrapSelector).addClass('d-none').filter("[data-variant='"+target.value+"']").removeClass('d-none');
};
SystemsightEshop.prototype.onCartQuantityChange = function (target, e) {
    var that = this;
    var quantity = parseInt(target.value);
    if (quantity > 0) {
        clearTimeout(that.updateOrderItemQuantityTimeout)
        that.updateOrderItemQuantityTimeout = setTimeout(function () {
            target.disabled = true;
            that.updateOrderItemQuantity($(target).data("order-item"), target.value, $(target).data("token"), function (result) {
                if(result.status == 'error'){
                    that.showModal(null, '', result.error);
                }
                that.updateCartSummary();
            })
        }, 1000);

    }
};
SystemsightEshop.prototype.onCartDeleteItem = function (target, deleteUrl) {
    var that = this;
    $.ajax({
        url: deleteUrl,
        data: {
            ajax: true
        }
    }).done(function (result) {
        that.updateCartSummary();
        that.updateCartWidgets();
    })
};

//functions
SystemsightEshop.prototype.updateTimer = function ($timer) {
    var now = Math.round((new Date()).getTime() / 1000);
    var delta = now - $timer.data('start');
    var timeleft = $timer.data('value') - delta;

    $timer.find(".v").html(timeleft)

    if (timeleft <= 0) {

        if ($timer.data('reload')) {
            window.location.reload();
        }
    }

}

SystemsightEshop.prototype.updateVariantPrice = function ($itemWrap, variantId) {
    var that = this;
    var $priceWrap = $itemWrap.find(that.options.variantPriceSelector);
    var prices = $priceWrap.data('prices');
    if (prices[variantId]) {
        $priceWrap.html(prices[variantId]);
    } else {
        $priceWrap.html('---')
    }
};
SystemsightEshop.prototype.updateCartWidgets = function (params) {
    params = params || {};

    var that = this;
    $(that.options.cartWidgetSelector).each(function () {
        var $widget = $(this);
        $.ajax({
            url: that.options.baseUrl + that.options.cartWidgetUrl,
            data: {
                ajax: true
            }
        }).done(function (result) {
            $widget.replaceWith(result);
            that.initCartTimeleftTrackers();

            if(typeof params.after_update_callback === "function"){
                params.after_update_callback($widget);
            }
        })
    })

};
SystemsightEshop.prototype.showFormPreloader = function ($target) {
    var that = this;
    $target
        .fadeTo(0.3, 0.5)
        .addClass('position-relative')
        .css('pointer-events', 'none')
    ;
    $('body').append(that.options.preloaderHtml)
}
SystemsightEshop.prototype.hideFormPreloader = function ($target) {
    var that = this;
    $target
        .fadeTo(0, 1)
        .removeClass('position-relative')
        .css('pointer-events', 'auto')
    ;
    $('body').find("#eshop-form-preloader").remove();
}
SystemsightEshop.prototype.updateCartSummary = function () {
    var that = this;
    that.showFormPreloader($(that.options.cartSummarySelector));
    $.ajax({
        url: that.options.baseUrl + that.options.cartUrl,
        data: {
            ajax: true
        }
    }).done(function (result) {
        $(that.options.cartSummarySelector).replaceWith(
            result
        );
        that.initCartTimeleftTrackers();
        that.hideFormPreloader($(that.options.cartSummarySelector));
    })
};

/**
 * @deprecated
 * @param data
 */
SystemsightEshop.prototype.openAfterAddToCart = function (data) {
    var that = this;

    if (that.openAfterAddToCart_xhr) that.openAfterAddToCart_xhr.abort();

    that.openAfterAddToCart_xhr = $.ajax({
        url: that.options.baseUrl + that.options.afterAddToCartUrl,
        data: {
            ajax: true,
            data: data
        }
    }).done(function (result) {
        $('body').append(result);
        $("#afterAddPopupModal").modal({}).on('hidden.bs.modal', function (e) {
            $("#afterAddPopupModal").remove();
        })
    })
};

//API calls
SystemsightEshop.prototype.add2Cart = function (variants, token, callback) {
    var that = this;
    var xhr = $.ajax({
        url: that.options.baseUrl + that.options.add2CartUrl,
        data: {
            variants: variants.join("-"),
            ajax: true,
            useAfterAddPopup: that.options.useAfterAddPopup,
            _token: token
        }
    }).done(function (result) {
        if(typeof result === "string"){
            //something is wrong
            location.reload();
        }else if (result.status === "ok") {
            if(result.modal){
                var $modal = $(result.modal);
                $('body').append($modal);
                new bootstrap.Modal($modal[0], {}).show();
                $modal.on('hidden.bs.modal', function (event) {
                    $modal.remove();
                })
            }
        } else if (result.status == "error" && result.error.length > 0) {
            that.showModal(null, '', result.error);
        }
        if (callback) {
            callback(result)
        }

        that.updateCartWidgets();
    })
};
SystemsightEshop.prototype.updateOrderItemQuantity = function (order_item, quantity, token, callback) {
    var that = this;
    $.ajax({
        url: that.options.baseUrl + that.options.updateCartItemQuantityUrl,
        data: {
            order_item: order_item,
            quantity: quantity,
            ajax: true,
            _token: token
        }
    }).done(function (result) {
        if (result.success) {
            if (callback) {
                callback(result)
            }
        }
    })
};
SystemsightEshop.prototype.updateShippingMethodPrice = function () {
    var that = this;
    let order = typeof CART_ORDER_ID != 'undefined' ? CART_ORDER_ID : null;
    let $shippingMethodInput = $(that.options.cartShippingFormSelector)
        .find(that.options.cartShippingMethodInputSelector)
    ;

    let $shippingMethodCountryInput = $(that.options.cartShippingFormSelector)
        .find(that.options.cartShippingCountryInputSelector)
    ;

    $(that.options.cartShippingPriceSelector).html('<i class="fa fa-cog fa-spin fa-fw"></i>');

    that.getShippingMethodPrice(order, $shippingMethodInput.val(), $shippingMethodCountryInput.val(), function (price) {
        $(that.options.cartShippingPriceSelector).html(price);
    });
};
SystemsightEshop.prototype.getShippingMethodPrice = function (order, shippingMethod, country, onDone) {
    var that = this;
    $.ajax({
        url: that.options.baseUrl + that.options.shippingPriceUrl,
        data: {
            ajax: true,
            shipping_method: shippingMethod,
            country: country
        }
    }).done(function (result) {
        onDone(result);
    });
};


SystemsightEshop.prototype.showModal = function($target, title, message){
    if(!$target) $target = $('body');

    if(Array.isArray(message)){
        message = message.join('\n');
    }

    var modalHtml =
        '<div class="modal fade" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">'
            + '<div class="modal-dialog">'
            + '<div class="modal-content">'
                + '<div class="modal-header">'
                    + '<h5 class="modal-title" id="exampleModalLabel">'+title+'</h5>'
                    + '<button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>'
                + '</div>'
                + '<div class="modal-body">'+message+'</div>'
            + '</div>'
            + '</div>'
        + '</div>'
    ;
    var $modal = $(modalHtml);
    $target.append($modal)

    new bootstrap.Modal($modal[0], {}).show();
    $modal.on('hidden.bs.modal', function (event) {
        $modal.remove();
    })

};
SystemsightEshop.formatMoney = function(price){
    var formated = (price / 100).toFixed(2);

    if($('html').attr("lang") == "lt"){
        formated = formated.replace(".", ",");
    }

    return formated;
};
var systemsightEshop;
$(function () {
    systemsightEshop = new SystemsightEshop({})
});
